import { render, staticRenderFns } from "./pal.vue?vue&type=template&id=fc3bd0de&"
import script from "./pal.vue?vue&type=script&lang=js&"
export * from "./pal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports